import React from 'react';

const PrivacyPolicy = () => (
  <div style={{ maxWidth: 800, margin: '40px auto', padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
    <h1>Privacy Policy</h1>
    <p>Last updated: July 2, 2024</p>
    <p>
      This Privacy Policy describes how we collect, use, and protect your personal information when you use our platform. By accessing or using our services, you agree to the terms of this Privacy Policy.
    </p>
    <h2>Information We Collect</h2>
    <ul>
      <li><strong>Personal Information:</strong> Name, email address, phone number, and other information you provide during registration or profile completion.</li>
      <li><strong>Usage Data:</strong> Information about how you use our website and services.</li>
      <li><strong>Device Information:</strong> IP address, browser type, device type, and operating system.</li>
    </ul>
    <h2>How We Use Your Information</h2>
    <ul>
      <li>To provide and maintain our services</li>
      <li>To communicate with you about your account or our services</li>
      <li>To improve our platform and user experience</li>
      <li>To comply with legal obligations</li>
    </ul>
    <h2>Information Sharing</h2>
    <p>
      We do not sell or rent your personal information to third parties. We may share your information with trusted partners who assist us in operating our platform, as required by law, or to protect our rights.
    </p>
    <h2>Data Security</h2>
    <p>
      We implement reasonable security measures to protect your information. However, no method of transmission over the Internet or electronic storage is 100% secure.
    </p>
    <h2>Your Rights</h2>
    <ul>
      <li>You may access, update, or delete your personal information by contacting us.</li>
      <li>You may opt out of receiving marketing communications at any time.</li>
    </ul>
    <h2>Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.
    </p>
    <h2>Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy, please contact us at contact.gogig@gmail.com.
    </p>
  </div>
);

export default PrivacyPolicy; 